import * as React from "react";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { wrapInTooltip } from "../../utils/methods";

interface MenuProps {
  content: any;
  menuItems: {
    content: any;
    action: () => void;
    disabled?: boolean;
  }[];
  classNames?: string;
  disabled?: boolean;
  disabledTooltip?: string;
}

const BasicMenu: React.FC<MenuProps> = ({ content, menuItems, classNames, disabled, disabledTooltip }) => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  let button = (
    <Button
      fullWidth={false}
      style={{ minWidth: "0px", padding: 0 }}
      id="basic-button"
      aria-controls={open ? "basic-menu" : undefined}
      aria-haspopup="true"
      aria-expanded={open ? "true" : undefined}
      onMouseDown={handleClick}
      disabled={disabled}
    >
      <>{content}</>
    </Button>
  );
  if (disabled && disabledTooltip) {
    button = wrapInTooltip(content, disabledTooltip);
  }
  return (
    <div className={classNames}>
      {button}
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
      >
        {menuItems.map((menuItem, index) => {
          return (
            <MenuItem
              key={index}
              onClick={() => {
                handleClose();
                menuItem.action();
              }}
              disabled={menuItem.disabled}
            >
              {menuItem.content}
            </MenuItem>
          );
        })}
      </Menu>
    </div>
  );
};
export default BasicMenu;
